module.exports = __webpack_public_path__ + "img/proibido-direita.aac1b635.png";